import { render, staticRenderFns } from "./AccountRemove.vue?vue&type=template&id=fc45b60c"
var script = {}
import style0 from "./AccountRemove.vue?vue&type=style&index=0&id=fc45b60c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports